import r_shelter from '../../../assets/img/marker/m_r-shelter.png';
import e_shelter from '../../../assets/img/marker/m_e-shelter.png';
import w_shelter from '../../../assets/img/marker/m_w-shelter.png';
import m_place from '../../../assets/img/marker/m_m-place.png';
import park from '../../../assets/img/marker/m_park.png';
import speaker from '../../../assets/img/marker/m_speaker.png';
import camera from '../../../assets/img/marker/m_camera.png';
import shoukasen from '../../../assets/img/marker/m_shoukasen.png';
import boukasuisou from '../../../assets/img/marker/m_boukasuisou.png';
import shoukaki from '../../../assets/img/marker/m_shoukaki.png';
import shobokiko from '../../../assets/img/marker/m_shobokiko.png';
import hospital from '../../../assets/img/marker/m_hospital.png';
import aed from '../../../assets/img/marker/m_aed.png';
import garbage_station from '../../../assets/img/marker/m_garbage-station.png';
import bbs from '../../../assets/img/marker/m_bbs.png';
import public_phone from '../../../assets/img/marker/m_public-phone.png';
import vending_machine from '../../../assets/img/marker/m_vending-machine.png';
import waterwray from '../../../assets/img/marker/m_waterwray.png';
import d_area from '../../../assets/img/marker/m_d-area.png';
import d_road from '../../../assets/img/marker/m_d-road.png';
import hazardous_area from '../../../assets/img/marker/m_hazardous-area.png';
import n01 from '../../../assets/img/marker/m_n01.png';
import evacuation_shelter from '../../../assets/img/marker/m_evacuation-shelter.png'
import reservoir from '../../../assets/img/marker/m_reservoir.png';
import lv2 from '../../../assets/img/marker/m_lv2.png';
import lv0 from '../../../assets/img/marker/m_lv0.png';

import m_pin_blue from '../../../assets/img/marker/m_pin_blue.png';
import m_pin_gray from '../../../assets/img/marker/m_pin_gray.png';
import m_pin_green from '../../../assets/img/marker/m_pin_green.png';
import m_pin_orange from '../../../assets/img/marker/m_pin_orange.png';
import m_pin_purple from '../../../assets/img/marker/m_pin_purple.png';
import m_pin_red from '../../../assets/img/marker/m_pin_red.png';
import m_pin_sky from '../../../assets/img/marker/m_pin_sky.png';
import m_pin_yellow from '../../../assets/img/marker/m_pin_yellow.png';


const category2icon = {
    "届出避難所": r_shelter,
    "緊急避難所": e_shelter,
    "福祉避難所": w_shelter,
    "集会所": m_place,
    "公園": park,
    "拡声塔": speaker,
    "防犯カメラ": camera,
    "消火栓": shoukasen,
    "防火水そう": boukasuisou,
    "消化器": shoukaki,
    "消防機庫": shobokiko,
    "病院・薬局": hospital,
    "AED": aed,
    "ゴミステーション": garbage_station,
    "掲示板": bbs,
    "公衆電話": public_phone,
    "自販機": vending_machine,
    "水路": waterwray,
    "危険箇所": d_area,
    "狭い・危険な道": d_road,
    "危険区域": hazardous_area,
    "その他": n01,
};

const spotList = [
    { src: r_shelter, name: "届出避難所", type: "rShelter" },
    { src: e_shelter, name: "緊急避難所", type: "eShelter" },
    { src: w_shelter, name: "福祉避難所", type: "wShelter" },
    { src: m_place, name: "集会所", type: "mPlace" },
    { src: park, name: "公園", type: "park" },
    { src: speaker, name: "拡声塔", type: "speaker" },
    { src: camera, name: "防犯カメラ", type: "camera" },
    { src: shoukasen, name: "消火栓", type: "shoukasen" },
    { src: boukasuisou, name: "防火水そう", type: "boukasuisou" },
    { src: shoukaki, name: "消火器", type: "shoukaki" },
    { src: shobokiko, name: "消防機庫", type: "shobokiko" },
    { src: hospital, name: "病院・薬局", type: "hospital" },
    { src: aed, name: "AED", type: "aed" },
    { src: garbage_station, name: "ゴミステーション", type: "garbageStation" },
    { src: bbs, name: "掲示板", type: "bbs" },
    { src: public_phone, name: "公衆電話", type: "publicPhone" },
    { src: vending_machine, name: "自販機", type: "vendingMachine" },
    { src: waterwray, name: "水路", type: "waterWray" },
    { src: d_area, name: "危険箇所", type: "dArea" },
    { src: d_road, name: "狭い・危険な道", type: "dRoad" },
    { src: hazardous_area, name: "危険区域", type: "hazardousArea" },
    { src: n01, name: "その他", type: "n01" },
]

export {
    category2icon,
    spotList
}
